import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";

const School = ({adminInfo}) => {
  const [loading, setLoading] = useState(true)
  const [schoolData, setSchoolData] = useState([])
  const [lang, setLang] = useState(adminInfo.test.lang.sort()[0]);
  const [region, setRegion] = useState("");
  const [schoolName, setschoolName] = useState("");

  const { t } = useTranslation();
  
  useEffect(() => {
    if(adminInfo.test){

      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getSchoolData = async(testId,adminId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/schools?testId="+testId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log("School Data: ",response.data) 
            setSchoolData(response.data["schools"])
            setLoading(false)
          }
          catch (error) {
            console.log(error)
            setLoading(false)
          }
        }
  
        getSchoolData(adminInfo.test ? adminInfo.test.testId : null, adminInfo.admin.adminId)
        
      })
      .catch((err) => console.log(err));
    }
    else alert("Test has not started yet")
    
  }, [adminInfo]);
  
  const columns = [
    {
      key: "name",
      headerName: t("commonItems.tableHeader_school"),
      width: 120
    },
    {
      key: "shift",
      headerName: t("commonItems.tableHeader_shift"),
      width: 40
    },
    { 
      key: "region", 
      headerName: t("commonItems.tableHeader_region"), 
      width: 80 
    },
    {
      key: "sectionCount",
      headerName: t("commonItems.tableHeader_noOfSections"),
      width: 80
    },
    { 
      key: "studentCount", 
      headerName: t("commonItems.tableHeader_studentsCount"), 
      width: 40 
    },
    // {
    //   key: "recCount",
    //   headerName: "Students Tested Count - " + adminInfo.allLangs[lang],
    //   width: 80
    // },
    {
      key: "recPercent",
      headerName: t("commonItems.tableHeader_studentsTested") + " - " + adminInfo.allLangs[lang] + " (%)",
      width: 80,
      percent: true
    }
  ];

  // if(adminInfo?.test?.status === 3) columns.push({
  //   key: "viewPercent",
  //   headerName: "Intervention Material Viewed - " + adminInfo.allLangs[lang] + " (%)",
  //   width: 80,
  //   percent: true
  // })

  const headers = [
    { label: "School Name", key: "name" },
    { label: "Shift", key: "shift" },
    { label: "Region", key: "region" },
    { label: "Number Of Sections", key: "sectionCount" },
    { label: "Students Count", key: "studentCount" },
    { label: "Students Tested Count - " + adminInfo.allLangs[lang], key: "recCount"},
    { label: "Students Tested - " + adminInfo.allLangs[lang] + " (%)", key: "recPercent" },
    // { label: "Intervention Material File Count - " + adminInfo.allLangs[lang], key: "fileCount" },
    // { label: "Intervention Material View Count - " + adminInfo.allLangs[lang], key: "viewCount" },
    // { label: "Intervention Material Viewed - " + adminInfo.allLangs[lang] + " (%)", key: "viewPercent" }
  ];

  const handleLangChange = (e) => {
    setLang(e.target.value);
  };
  
  const handleRegionChange = (e) => {
    if (e.target.value ==="" ) setschoolName("")
    setRegion(e.target.value);
  };
  
  const handleSchoolNameChange = (e) => {
    setschoolName(e.target.value);
  };
  
  var filteredSchoolData
  if(region==="" || (region==="" && schoolName==="")){
    filteredSchoolData = schoolData
  }
  else if(region!=="" && schoolName===""){
    filteredSchoolData = [...schoolData.filter(item => item.region === region)]
  }
  else{
    filteredSchoolData = [...schoolData.filter(item => item.region === region && item.name === schoolName)]
  }
  // console.log(schoolData)
  // console.log(filteredSchoolData)

  return (
    <div className="schoolContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("admin.school.title")}{adminInfo.test ? <span> - {adminInfo.test.testName}</span>: ""}
      </h2>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
            <Select
              labelId="langFilterLabel"
              id="langFilter"
              value={lang}
              onChange={handleLangChange}
              autoWidth
              label={t("commonItems.dropdownLabel_lang")}
            >
              {adminInfo.test &&
                adminInfo.test.lang.sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{adminInfo.allLangs[item]}</MenuItem>   
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
            <Select
              labelId="regionFilterLabel"
              id="regionFilter"
              value={region}
              onChange={handleRegionChange}
              autoWidth
              label={t("commonItems.dropdownLabel_region")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique region values from data */}
              {[...new Set(schoolData.map(item => item.region))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="schoolNameFilterLabel">{t("commonItems.dropdownLabel_school")}</InputLabel>
            <Select
              labelId="schoolNameFilterLabel"
              id="schoolNameFilter"
              value={schoolName}
              onChange={handleSchoolNameChange}
              autoWidth
              label={t("commonItems.dropdownLabel_school")}
            >
              {region===""? 
                <MenuItem disabled>Select Region First</MenuItem>
                :
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
              }
              {[...new Set(schoolData.filter(item => item.region === region).map(item => item.name))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="tabs">
        <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
          <CSVLink 
            data={filteredSchoolData.map(item => {
              let counts = item.counts[lang]
              return {
                ...item,
                ...counts,
                "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
              }
            })} 
            headers={headers} 
            filename={"SchoolData - " + adminInfo.allLangs[lang] + ".csv"}
          >
            {t("commonItems.buttonLabel_csvDownload")}
          </CSVLink>
        </Button>
      </div>
      <Divider />
      <div className="table">
        <Table
          columns={columns}
          tableData={filteredSchoolData.map(item => {
            let counts = item.counts[lang]
            return {
              ...item,
              ...counts,
              "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
              "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
            }
          })}
          orderBy={["recPercent", "viewPercent", "studentCount"]} 
          tableHeight="calc(100vh - 318px)"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default School;
